<template>
  <div class="h-100 vis-base-grid">
    <DxDataGrid
      class="h-100"
      :data-source="dataSource"
      :show-borders="true"
      :rowAlternationEnabled="true"
      :focused-row-enabled="true"
      :on-initialized="onInitialized"
      :on-selection-changed="onSelectionChange"
      :on-row-dbl-click="onDblClick"
      :selection="selection"
      :paging="{
        pageSize: 50,
        enabled: true,
      }"
      :pager="{
        visible: true,
        showPageSizeSelector: true,
        showInfo: true,
      }"
      :scrolling="{
        mode: 'standart',
        rowRenderingMode: 'standart',
      }"
      :remote-operations="{
        paging: true,
        sorting: true,
        filtering: true,
      }"
      :header-filter="{
        visible: true,
      }"
      :filter-row="{
        visible: true,
      }"
      :filter-panel="{
        visible: true,
      }"
    >
      <DxColumn type="buttons">
        <DxButton hint="DetailView" icon="fal fa-eye" :on-click="openDv" />
      </DxColumn>

      <DxColumn
        data-field="ID"
        width="100"
        :caption="'TrackerID'"
      />
      <DxColumn
        data-field="TerminalID"
        :caption="this.$t('gisTrackerList.columns.terminalId')"
      />
      <DxColumn
        data-field="Title"
        :caption="this.$t('gisTrackerList.columns.title')"
      />
    </DxDataGrid>
  </div>
</template>

<script>
import api from "@/api/visary-api";

import "devextreme/data/odata/store";

import {
  DxDataGrid,
  DxColumn,
  DxButton,
} from "devextreme-vue/data-grid";

import globalState from "@/shared/global-state";
import gridCommands from "@/views/base/list-view/commands/grid-commands";
import listViewCommands from "@/views/base/list-view/commands/list-view-commands";

export default {
  name: "vis-gistracker-grid",
  components: {
    DxDataGrid,
    DxColumn,
    DxButton,
  },
  props: {
    eventBus: { type: Object },
    selectionColumn: { type: Boolean, default: true },
    onlySingleSelect: { type: Boolean, default: true },
  },
  data() {
    let self = this;

    return {
      gridInstance: null,
      showHidden: false,
      dataSource: {
        store: {
          type: "odata",
          url: globalState.launchConfig.gisTrackerOdataBaseUrl + "/tracker",
          key: "ID",
          version: 4,
          onLoaded: function (result) {
            (async () => {
              await self.loadLookup(result);
            })();

            return result;
          }
        },
        select: [
          "ID",
          "TerminalID",
          "Title",
          "Hidden"
        ]
      },
      selection: {
        mode: self.selectionColumn
          ? self.onlySingleSelect
            ? "single"
            : "multiple"
          : "none",
          selectAllMode: "page",
          allowSelectAll: true,
      },
    };
  },
  methods: {
    async openDv(e) {
       const data = await this.getData(e);
       this.$emit("detailview", data);
    },
    async getData(e) {
      const data = e.row.data;

      let res = {
        title: "GisTracker #" + data.ID,
        mnemonic: "GisTracker",
        entityId: data.ID,
        data: data.Data ? JSON.stringify(JSON.parse(data.Data), null, "\t") : ""
      };

      return res;
    },
    async loadLookup(items) {
      for (let index = 0; index < items.length; index++) {
        // for future
      }
    },
    onInitialized(e) {
      this.gridInstance = e.component;
    },
    onSelectionChange({ selectedRowKeys, selectedRowsData }) {
      let single = null;
      const count = selectedRowsData.length;

      if (count === 1) {
        single = selectedRowsData[0];
      }

      this.$emit("select", {
        single: single,
        keys: selectedRowKeys,
        items: selectedRowsData,
        source: "row",
        count: count,
      });
    },
    onDblClick({ data, rowType }) {
      if (rowType === "group") return;
      if (this.gridInstance.getSelectedRowKeys().length > 1) return;

      this.$emit("dblclick", {
        data: data,
      });
    },
  },

  created() {
    const self = this;

    if (this.eventBus) {
      this.eventBus.$on(gridCommands.refresh, function () {
        if (self.gridInstance) self.gridInstance.refresh();
      });


      this.eventBus.$on(listViewCommands.showHidden, function () {
        self.showHidden = !self.showHidden;
        self.gridInstance.filter([["Hidden", "=", self.showHidden]])

      });
    }
  },

  mounted() {
    this.gridInstance.filter([["Hidden", "=", this.showHidden]]);
  }

};
</script>
